import React, { FC } from 'react';

import IconCreditCard from '@zvuk-b2b/react-uikit/ui/icons/CreditCard';

import { TEXTS } from './texts';

import styles from './index.module.scss';

const CardEmpty: FC = () => (
  <div className={styles.CardEmpty}>
    <IconCreditCard className={styles.CardEmptyIcon} />
    <div className={styles.CardEmptyText}>{TEXTS.EMPTY_CARD_TEXT}</div>
  </div>
);

export default React.memo(CardEmpty);
